import { render, staticRenderFns } from "./mrfiktiv.vue?vue&type=template&id=2a660e8c&"
import script from "./mrfiktiv.vue?vue&type=script&lang=ts&"
export * from "./mrfiktiv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports